import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { GET_OFFICERS } from '../constant';
import { getOfficers } from '../action';

const selectList = ({ api }) => {
  return _.get(api, `${GET_OFFICERS}.list`) || [];
};

const formatOptions = data => {
  return data.map(item => {
    return {
      label: `${_.get(item, 'attributes.dno')} - ${_.get(item, 'attributes.name')}`,
      value: item.id,
      fullInfo: item,
    };
  });
};

const ApprehendingOfficerDropdown = ({ name, onChange, value, readOnly }) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = [
    ...formatOptions(list),
  ];

  const [inputtedValue, setInputtedValue] = useState('');
  
  const findValue =
    options.find(item => {
      return (
        +_.get(item, 'value') === value  ||
        '') 
    })

  useEffect(() => {
    if (_.isEmpty(value))
      dispatch(getOfficers({ q: '' }));
  }, [value]);

  const handleChange = data => {
    onChange({
      target: {
        name,
        value: data ? data.value : '',
        label: data ? data.label : '',
      },
    });
  };

  const handleInputChange = (valueInput, x) => {
    if (x.action === "input-change") {
      setInputtedValue(valueInput);
    }

    if (x.action === 'menu-close' && _.isEmpty(valueInput)) {
      dispatch(
        getOfficers({ q: '' }, response => {
          (formatOptions(_.get(response, 'data')));
        })
      );
    }

  };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      getOfficers({ q: inputtedValue }, response => {
        callback(formatOptions(_.get(response, 'data')));
      })
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      placeholder="Select Apprehending Officer"
      value={findValue}
      onChange={handleChange}
      onInputChange={handleInputChange}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      components={{
        IndicatorSeparator: () => null,
      }}
      blurInputOnSelect
      isClearable
    />
  );
};

ApprehendingOfficerDropdown.defaultProps = {
  name: undefined,
  readOnly: undefined,
};

ApprehendingOfficerDropdown.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
};

export default ApprehendingOfficerDropdown;
